import { date, object, string } from "yup";

export const addRegistrationSchema = object().shape({
  existingTaxAccount: string(),
  tax_detail_id: string().when("existingTaxAccount", {
    is: "YES",
    then: (schema) => schema.required("Existing tax accounts ID is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  filing_start_date: date().required("Filing start date is required"),
  state_id: string().when("state_registration_id", {
    is: (val: string) => !!val,
    then: string().required("State ID is required "),
    otherwise: string().notRequired(),
  }),
});

export const addRegistrationAdminSchema = object().shape({
  state_id: string().when("state_registration_id", {
    is: (val: string) => !!val,
    then: string().required("State ID is required "),
    otherwise: string().notRequired(),
  }),
  filing_start_date: date().required("Filing start date is required"),
  payment_schedule: string().required("Payment schedule is required"),
  sales_tax_id: string().required("Sales tax ID is required"),
});
